export const localDatabaseKey = {
    firebaseAuthToken: 'firebase_auth_token',
};
